"use client";

import type { ReactNode } from "react";
import { isHighTierModelId } from "@/lib/ai/model-tier";
import type { ModelId } from "@/lib/ai/models";
import { ModelSelectProBadge } from "./model-select-pro-badge";
import { ModelSelectQuotaWeightBadge } from "./model-select-quota-weight-badge";

type Props = {
  modelId: ModelId;
  label: ReactNode;
};

export function ModelSelectOptionLabel({ modelId, label }: Props) {
  return (
    <div className="flex min-h-5 min-w-0 flex-1 items-center leading-none">
      <span className="relative top-px min-w-0 truncate leading-none">
        {label}
      </span>
      {isHighTierModelId(modelId) ? (
        <ModelSelectProBadge className="ml-2" />
      ) : null}
      <ModelSelectQuotaWeightBadge modelId={modelId} className="ml-2" />
    </div>
  );
}
